/**
 * Maquinas/Equipamentos Module Routes — granular (2026-04-21)
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

const MaquinasLista = lazy(() => import("@/pages/maquinas/Lista"));
const DashboardMaquinas = lazy(() => import("@/pages/maquinas/Dashboard"));
const EquipamentosLista = lazy(() => import("@/pages/maquinas/Equipamentos"));
const EquipmentTypesPage = lazy(() => import("@/pages/admin/EquipmentTypes"));
const EquipmentDashboard2 = lazy(() => import("@/pages/EquipmentDashboard2"));
const EquipmentDetailsPage = lazy(() => import("@/pages/EquipmentDetailsPage"));

export const maquinasRoutes: ModuleRoutes = {
  moduleId: "maquinas",
  basePath: "/maquinas",
  routes: [
    {
      path: "/maquinas/lista",
      element: <MaquinasLista />,
      permission: { resource: "maquinas_lista", action: "view" },
    },
    {
      path: "/maquinas/dashboard",
      element: <DashboardMaquinas />,
      permission: { resource: "maquinas_dashboard", action: "view" },
    },
    {
      path: "/maquinas/equipamentos",
      element: <EquipamentosLista />,
      permission: { resource: "maquinas_lista", action: "view" },
    },
    {
      path: "/maquinas/tipos",
      element: <EquipmentTypesPage />,
      permission: { resource: "maquinas_tipos", action: "manage" },
    },
    // Rotas legadas /equipments/*
    {
      path: "/equipments",
      element: <EquipmentDashboard2 />,
      permission: { resource: "maquinas_dashboard", action: "view" },
    },
    {
      path: "/equipments/:id",
      element: <EquipmentDetailsPage />,
      permission: { resource: "maquinas_lista", action: "view" },
    },
  ],
};
